export class User {
    id:number;
    name: string;
    last_name: string;
    email: string;
    phone: string;
    gender: string;

    constructor(name:string, last_name:string){
        this.name = name;
        this.last_name = last_name;
        this.id = new Date().getTime();
    }
}